<template>
    <vue-final-modal
        @opened="opened"
        v-bind="$attrs"
        v-slot="{ close }"
        :esc-to-close="true"
    >
        <div class="opui-modal opui-modal-course-edit">
            <div class="opui-modal-dialog opui-mw-900">
                <div class="opui-modal-content">
                    <div class="opui-modal-header">
                        <h1>{{ title ? title : 'Error' }}</h1>
                        <i @click.prevent="close" class="opui-icon-close opui-modal-close"></i>
                    </div>

                    <div class="opui-modal-body">
                        <p v-html="text ? text : $e('Error!')"></p>

                        <div class="opui-form-actions">
                            <button class="opui-btn opui-btn-danger opui-float-right" @click="$emit('confirm', close)">
                                <span class="opui-btn-label">Close</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </vue-final-modal>
</template>

<script>
export default {
    props: {
        title: { type: String },
        text:  { type: String },
    }
}
</script>

<style>
.opfl-plugin-list {
    margin: 20px !important;
    list-style-type: disc !important;
    font-size: 15px !important;
}
</style>
